<template>
	<div>
		<h1>Authentication</h1>
		<form v-if="!loggedIn" v-on:submit.prevent="login">
			<div class="form-row form-group">
				<div class="col-auto">
					<input type="text" class="form-control" autocomplete="username" placeholder="username" v-model="username">
				</div>
				<div class="col-auto">
					<input type="password" class="form-control" autocomplete="current-password" placeholder="password" v-model="password">
				</div>
				<button class="btn btn-primary" type="submit">Login</button>
			</div>
		</form>
		<ul>
			<li>
				<h3 style="color:red;">{{nodeId}}</h3>
				<ul>
					<li v-for="session in sessionLookupByNode[nodeId]" :key="session.$id">
						{{session.username || session.account}} ({{session.$id}})
					</li>
				</ul>
			</li>
			<li v-for="( sessions, thisNodeId ) in sessionLookupByNode" v-if="thisNodeId != nodeId" :key="thisNodeId">
				<h3>{{thisNodeId}}</h3>
				<ul>
					<li v-for="session in sessions" :key="session.$id">
						{{session.username || session.account}} ({{session.$id}})
					</li>
				</ul>
			</li>
		</ul>
		<form v-if="loggedIn" v-on:submit.prevent="logout">
			You are logged in! Here is your session info:
			<pre style="text-align: left; border: 1px solid #999;">{{sessionData}}</pre>
			<button class="btn btn-danger" type="submit">Logout</button>
		</form>
	</div>
</template>

<script>


// SEE: https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex



import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
	name: "authentication-view",
	props : [ 'nodeId', 'authRedirect' ],
	data() {
		return {
			username: "",
			password: "",
		};
	},
	computed: {
		loggedIn : function( ) {
			return !!this.$store.getters['authentication/sessionKey'];
		},
		sessionData : function( ) {
			return JSON.stringify( this.$store.state.authentication.session, null, 2 );
		},
		...mapGetters( "authentication", [
			"sessionLookupByNode",
			"sessionLookup",
			"sessionList"
		]),
	},
	methods:
	{
		login : async function( )
		{
			if( !this.username || !this.password )
				return alert( "[Authentication] Must provide a username AND password!" );
			
			try {
				console.log( "NODE ID:", this.nodeId );
				if( !( await this.$store.dispatch( 'authentication/login', { nodeId : this.nodeId, username : this.username, password : this.password } ) ) )
					alert( "Login failed!!" );
				console.log( "[Authentication] LOGGED IN!", this.loggedIn );
				console.log( "[Authentication] REDIRECT:", this.authRedirect );
				if( this.authRedirect )
					try {
						this.$router.replace( this.authRedirect );
					} catch( err ) {
						console.warn( "[Authentication] WARNING: Post auth redirect failed to:", err );
						console.error( err );
					}
			} catch( err ) {
				console.error( "[Authentication] Technical login error:", err );
			}
		},
		...mapActions({
			//login: "authentication/login",
			logout: "authentication/logout",
			listProjects: "projects/list",
		})
	},
	mounted()
	{
		//console.log( "[Authentication] PARAMS:", this.$route.params );
	},
	created( )
	{
		console.log( "[Authentication] CREATED ("+ this.nodeId +")" );
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Authentication.vue